import { GAME_COLLECTION_TAG_PATHS } from '@suntex.fim/framework';

import { NodeModel } from '../../../types';

import { modulesNode } from './modules';

export const fractionsFestNode: NodeModel = {
  tag: GAME_COLLECTION_TAG_PATHS.fractionsFest,
  alias: ['fractionsfest'],
  info: {
    title: 'Fractions Fest',
  },
  label: 'Fractions Fest',
  color: 0x00cc88,
  filterTagPath: GAME_COLLECTION_TAG_PATHS.fractionsFest,
  filterRoot: modulesNode,
};
